exports = module.exports = require("../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gdpr-modal{background:#fff;width:80%;margin:0 auto;padding:2em 4em 2em;border-radius:16px;z-index:9999999;position:absolute}.gdpr-content-modal{margin-top:10px;height:80%;overflow-y:scroll}.gdpr-content-modal div{max-height:100%}.gdpr-modal h3{margin-top:15px;margin-bottom:15px}.gdpr-modal img{display:block;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../lunch-team-client-checkout-msg/node_modules/css-loader!../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/containers/GDPR/GDPRModal/GDPRModal.scss
// module id = 631
// module chunks = 7